document.addEventListener('DOMContentLoaded', () => {
    const tables = document.querySelectorAll('.wysiwyg-area table')

    tables.forEach((table) => {
        const wrapper = document.createElement('div')
        wrapper.classList.add('table-responsive')

        table.parentNode.insertBefore(wrapper, table)
        wrapper.appendChild(table)
    })
})